import React from 'react';
import appService from '../services/appService';

const AppCard = ({ app, onEdit, onDelete, isAdmin }) => {
  const handleOpenApp = () => {
    appService.openApp(app.id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(app);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer "${app.name}" ?`)) {
      onDelete(app.id);
    }
  };

  return (
    <div 
      className="app-card group"
      style={{ borderLeftColor: app.color }}
      onClick={handleOpenApp}
    >
      <div className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-4">
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center text-2xl font-bold text-white"
              style={{ backgroundColor: app.color }}
            >
              {app.icon || '🔧'}
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                {app.name}
              </h3>
              <p className="text-gray-600 text-sm mt-1">
                {app.description}
              </p>
              {app.category && (
                <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full mt-2">
                  {app.category}
                </span>
              )}
            </div>
          </div>
          
          {isAdmin && (
            <div className="flex items-center space-x-2 admin-buttons">
              <button
                onClick={handleEdit}
                className="text-blue-600 hover:text-blue-800 p-1"
                title="Modifier"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              <button
                onClick={handleDelete}
                className="text-red-600 hover:text-red-800 p-1"
                title="Supprimer"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          )}
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center space-x-4 text-sm text-gray-500">
            <span className="flex items-center">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              Port {app.port}
            </span>
            {app.requiresAuth && (
              <span className="flex items-center text-green-600">
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Sécurisé
              </span>
            )}
          </div>
          
          <div className={`status-indicator ${app.active ? 'bg-green-500' : 'bg-red-600'}`} title={app.active ? 'Actif' : 'Inactif'}>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppCard;
